import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ChatBackgroundImageSize, ChatBackgroundType } from 'APP/constants/appearance';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';

import { useChatBackgroundPresenter } from './ChatBackground.presenter';
import { ChatBackgroundImage } from './ChatBackgroundImage/ChatBackgroundImage';
import { ChatBackgroundPattern } from './ChatBackgroundPattern/ChatBackgroundPattern';

interface TChatBackgroundProps {
  background?: TChatBackground;
  size?: ChatBackgroundImageSize;
}

export const ChatBackground: FC<TChatBackgroundProps> = observer(
  ({ background, size = ChatBackgroundImageSize.Original }) => {
    const presenter = useChatBackgroundPresenter(background);

    return (
      <>
        {presenter.chatBackground.type === ChatBackgroundType.Pattern && (
          <ChatBackgroundPattern pattern={presenter.chatBackground.background} />
        )}
        {presenter.chatBackground.type !== ChatBackgroundType.Pattern && (
          <ChatBackgroundImage
            background={presenter.chatBackground}
            size={size}
          />
        )}
      </>
    );
  }
);
